import logger from '../../../../core/utils/src/logger';
export default function createDeprecationWarnings(componentName) {
    function printDeprecationPropertyWarning(property, replacement) {
        return logger.warnOnce("[" + componentName + "]", "The `" + property + "` property has been deprecated. Use `" + replacement + "` instead.");
    }
    return {
        selectedId: function () { return printDeprecationPropertyWarning('selectedId', 'selectedOption'); },
        selectedIds: function () { return printDeprecationPropertyWarning('selectedIds', 'selectedOptions'); },
        loading: function () { return printDeprecationPropertyWarning('loading', 'statusType="loading"'); },
        enableFiltering: function () { return printDeprecationPropertyWarning('enableFiltering', 'filteringType="auto"'); }
    };
}
//# sourceMappingURL=deprecation-warnings.js.map